module.exports = __webpack_public_path__ + "img/calendar.5da07100.svg";